/* @flow */

import { rem } from 'polished';

import {
  baseFontSize,
  body2FontSize,
  body2FontWeight,
  body2LineHeight,
} from '@braindate/ui/lib/token/typography';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  dl: {
    margin: [rem(32, baseFontSize), 0, rem(24, baseFontSize)],
  },
  dt: {
    margin: [rem(24, baseFontSize), 0, rem(4, baseFontSize)],

    color: ({ theme }: ThemeFunction) => theme.accentColor,

    fontSize: rem(body2FontSize, baseFontSize),
    fontWeight: body2FontWeight,
    lineHeight: body2LineHeight / body2FontSize,
  },
  dd: {
    margin: [rem(4, baseFontSize), 0],
    padding: 0,
  },
};
